// removed by extract-text-webpack-plugin
module.exports = {"selectLabel":"_2lblzZ141YzwlQUGEpv9rR","selectBase":"_3V9wAUrlEe8qMFO8HiHgdH"};


//////////////////
// WEBPACK FOOTER
// ./src/react/ui/features/TextArea/TextAreaInput.styl
// module id = 749
// module chunks = 0